import React, { useEffect } from 'react';
import {
  Control,
  Controller,
  FieldErrors,
  UseFormRegister,
  UseFormWatch,
} from 'react-hook-form';
import { RegisterFormInputs } from '..';
import { errorStyle } from '../../../../../constants/styles';
import Button from '../../../../Button';
import { TextInput } from '../../../../Inputs';
import { useAuth } from '../../../AuthContextProvider';

interface RegisterPasswordProps {
  loading: boolean;
  setPasswordStrength: (v: any) => void;
  backStep: () => void;
  formProps: {
    control: Control<RegisterFormInputs, any>;
    errors: FieldErrors<RegisterFormInputs>;
    watch: UseFormWatch<RegisterFormInputs>;
    register: UseFormRegister<RegisterFormInputs>;
  };
}
export default function RegisterSetPasswordForm({
  loading,
  setPasswordStrength,
  backStep,
  formProps,
}: RegisterPasswordProps) {
  const { control, errors, watch, register } = formProps;

  const {
    config: { registerTermsText },
  } = useAuth();

  const watchPassword = watch(['password', 'password_confirmation']);

  useEffect(() => {
    setPasswordStrength({
      characters: watchPassword[0].length > 7,
      uppercase: /[A-Z]/.test(watchPassword[0]),
      special: /[\W_]/.test(watchPassword[0]),
      number: /[0-9]/.test(watchPassword[0]),
      match: watchPassword[0] !== '' && watchPassword[0] === watchPassword[1],
    });
  }, [watchPassword[0], watchPassword[1]]); // eslint-disable-line

  return (
    <div className="w-full max-w-sm">
      <div className="text-gray-300 text-xs w-full text-center mb-10">
        Step <strong>2</strong> of <strong>2</strong>
      </div>

      <div className="mt-6 rounded-md shadow-sm">
        <input type="hidden" {...register('name')} />
        <input type="hidden" {...register('email')} />

        <Controller
          name="password"
          control={control}
          defaultValue=""
          rules={{
            required: true,
          }}
          render={({ field: { onChange, value } }) => (
            <TextInput
              type="password"
              placeholder="Password"
              value={value}
              onChange={(v) => onChange(v)}
              invalid={!!errors.password}
            />
          )}
        />
        <div className="mt-6"></div>
        <Controller
          name="password_confirmation"
          control={control}
          defaultValue=""
          rules={{
            required: true,
          }}
          render={({ field: { onChange, value } }) => (
            <TextInput
              type="password"
              value={value}
              onChange={(v) => onChange(v)}
              invalid={!!errors.password}
              placeholder="Password Confirmation"
            />
          )}
        />
      </div>
      {errors.password && errors.password.type === 'required' && (
        <span className={errorStyle}>Password is required</span>
      )}

      {errors.password && errors.password.type === 'api' && (
        <span className={errorStyle}>{errors.password.message}</span>
      )}

      <div className="mt-8">
        <Button
          text="Create account"
          type="submit"
          buttonStyle="gradiented"
          loading={loading}
          disabled={loading}
        />
      </div>
      {registerTermsText}
      <div className="mt-6 text-gray-400 hover:text-gray-200 font-medium cursor-pointer text-xs">
        <a onClick={backStep}>{'<'} Back to account details</a>
      </div>
    </div>
  );
}
